import type { SchemaAttributes, Schemas } from '@/api/types.js'
import {
  createRelationshipBuilder,
  one,
  type RelationshipDefs,
} from '@/utils/jsonapi.js'
export type PatientHealthPlanItemAttributes =
  SchemaAttributes<'PatientHealthPlanItem'>

export const PatientHealthPlanItemTypeCodes = {
  Procedure: 'ITEM_TYPE_PROCEDURE',
  Medicine: 'ITEM_TYPE_MEDICINE',
  Supply: 'ITEM_TYPE_SUPPLY',
  Food: 'ITEM_TYPE_FOOD',
  LaboratoryAnalysis: 'ITEM_TYPE_LABORATORY_ANALYSIS',
  LaboratoryAnalysisPanel: 'ITEM_TYPE_LABORATORY_ANALYSIS_PANEL',
} as const

export type PatientHealthPlanItemTypeCode =
  (typeof PatientHealthPlanItemTypeCodes)[keyof typeof PatientHealthPlanItemTypeCodes]

export type NormalizedPatientHealthPlanItem = {
  id: string
  attributes?: PatientHealthPlanItemAttributes
  // relationships
  organizationItem?: Schemas['OrganizationItem']
}

const patientHealthPlanItemRelationships = {
  item: one('OrganizationItem'),
} satisfies RelationshipDefs<Schemas['PatientHealthPlanItem']>

export const buildPatientHealthPlanItemRelationships =
  createRelationshipBuilder(patientHealthPlanItemRelationships)
